<template>
	<transition
			appear
			:appear-active-class="$_csvStpLyt_stylePageLayoutAnimation()">
		<v-row class="customVRow">
			<v-col>
				<v-stepper
						v-model="stepNumber_"
						class="stepper_"
						:vertical="false">
					<v-stepper-header class="stepperHeader_">
						<v-stepper-step class="stepperStep_" :step="1">Add</v-stepper-step>
						<v-stepper-step class="stepperStep_" :step="2">Submit</v-stepper-step>
						<v-stepper-step class="stepperStep_" :step="3">Finished</v-stepper-step>
					</v-stepper-header>
					<!-- add -->
					<v-stepper-items class="stepperItem_">
						<v-stepper-content class="stepperContent_" :step="1">
							<validation-observer ref="observer" v-slot="validation">
								<v-form>
									<v-card class="customVCard">
										<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
											<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
												<v-row :key="contentKey" class="pa-3">
													<v-col>
														<v-row no-gutters>
															<v-col>
																<span v-text="contentVals.headerText" />
															</v-col>
														</v-row>
														<v-row no-gutters>
															<v-col>
																<!-- integer -->
																<template v-if="contentVals.dataType.integer">
																	<validation-provider
																			:name="contentKey"
																			:rules="contentVals.isNullable ? 'numeric' : 'required|numeric'"
																			v-slot="{ errors }">
																		<v-text-field
																				v-model="form_[contentKey]"
																				:error-messages="errors" />
																	</validation-provider>	
																</template>
																<!-- string -->
																<template v-if="contentVals.dataType.string">
																	<validation-provider
																			:name="contentKey"
																			:rules="contentVals.isNullable ? '' : 'required'"
																			v-slot="{ errors }">
																		<v-text-field
																				v-model="form_[contentKey]"
																				:error-messages="errors" />
																	</validation-provider>	
																</template>
																<!-- date -->
																<template v-if="contentVals.dataType.date">
																	<validation-provider
																			:name="contentKey"
																			:rules="contentVals.isNullable ? '' : 'required'"
																			v-slot="{ errors }">
																		<v-text-field
																				v-model="form_[contentKey]"
																				:error-messages="errors" />
																	</validation-provider>	
																</template>
																<!-- time -->
																<template v-if="contentVals.dataType.time">
																	<validation-provider
																			:name="contentKey"
																			:rules="contentVals.isNullable ? '' : 'required'"
																			v-slot="{ errors }">
																		<v-text-field
																				v-model="form_[contentKey]"
																				:error-messages="errors" />
																	</validation-provider>	
																</template>
																<!-- date time -->
																<template v-if="contentVals.dataType.dateTime">
																	<validation-provider
																			:name="contentKey"
																			:rules="contentVals.isNullable ? '' : 'required'"
																			v-slot="{ errors }">
																		<v-text-field
																				v-model="form_[contentKey]"
																				:error-messages="errors" />
																	</validation-provider>	
																</template>
																<!-- boolean -->
																<template v-if="contentVals.dataType.boolean">
																	<validation-provider
																			:name="contentKey"
																			:rules="contentVals.isNullable ? '' : 'required'"
																			v-slot="{ errors }">
																		<v-switch
																				v-model="form_[contentKey]"
																				:error-messages="errors" />
																	</validation-provider>	
																</template>
																<!-- json -->
																<template v-if="contentVals.dataType.json">
																	<validation-provider
																			:name="contentKey"
																			:rules="contentVals.isNullable ? '' : 'required'"
																			mode="lazy"
																			v-slot="{ errors }">
																		<v-text-field
																				v-model="form_[contentKey]"
																				:error-messages="errors" />
																	</validation-provider>	
																</template>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
											</template>
										</template>
									</v-card>
									<v-card	class="customVCard"
											color="transparent"
											flat>
										<v-row class="pt-3">
											<v-col>
												<v-row dense justify="center">
													<v-col cols="auto">
														<v-btn	class="customVBtn"
																:disabled="isEmpty(form_)"
																@click="$_csvStpLyt_clear()">
															Clear
														</v-btn>
													</v-col>
													<v-col cols="auto">
														<v-btn	class="customVBtn"
																:disabled="(!validation.passed && !validation.valid) || isEmpty(form_)"
																@click="$_csvStpLyt_add(false)">
															Add
														</v-btn>
													</v-col>
													<v-col cols="auto">
														<v-btn	class="customVBtn"
																:disabled="(!validation.passed && !validation.valid) || isEmpty(form_)"
																@click="$_csvStpLyt_add(true)">
															Add & Continue
														</v-btn>
													</v-col>
													<!-- csv file upload -->
													<v-col cols="auto">
														<v-dialog
																persistent
																v-model="showDialogUpload_"
																width="750px">
															<template v-slot:activator="{ on }">
																<v-btn	class="customVBtn"
																		color="primary"
																		v-on="on">
																	Upload By File
																</v-btn>
															</template>
															<v-card class="customVCard">
																<template v-if="!isFalse(errorMessageUpload_)">
																	<v-row>
																		<v-col>
																			<span style="color:red" v-text="errorMessageUpload_" />
																		</v-col>
																	</v-row>
																</template>
																<v-row>
																	<v-col>
																		<v-file-input
																				accept=".csv"
																				label="Select file to upload"
																				hide-details
																				outlined
																				show-size
																				:prepend-icon="null"
																				v-model="csvFileLocal_" />
																	</v-col>
																</v-row>
																<v-card-actions>
																	<v-row dense justify="center">
																		<v-col cols="auto">
																			<v-btn	class="customVBtn"
																					:disabled="isFalse(csvFileLocal_)"
																					@click="$_csvStpLyt_uploadByFile()">
																				Upload
																			</v-btn>
																		</v-col>
																		<v-col cols="auto">
																			<v-btn	class="customVBtn"
																					@click="showDialogUpload_ = !showDialogUpload_">
																				Close
																			</v-btn>
																		</v-col>
																	</v-row>
																</v-card-actions>
															</v-card>
														</v-dialog>
													</v-col>
													<v-col cols="auto">
														<v-btn	class="customVBtn"
																color="primary"
																@click="$_csvStpLyt_downloadCsvFormat()">
															Download CSV Format
														</v-btn>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-card>
								</v-form>
							</validation-observer>
						</v-stepper-content>
					</v-stepper-items>
					<!-- submit -->
					<v-stepper-items class="stepperItem_">
						<v-stepper-content class="stepperContent_" :step="2">
							<v-card class="customVCard">
								<template v-if="!isFalse(errorMessageSubmit_)">
									<v-row>
										<v-col>
											<span class="body-1" v-text="errorMessageSubmit_" />
										</v-col>
									</v-row>
								</template>
								<v-row class="pa-3">
									<v-col>
										<v-data-table
												:headers="$_csvStpLyt_getDataTableHeaders()"
												:items="$_csvStpLyt_getDataTableItems()">
											<template v-slot:[`item.action`]="{ item }">
												<v-row>
													<v-col cols="auto">
														<v-icon
																small
																@click="$_csvStpLyt_edit(item)">
															edit
														</v-icon>
													</v-col>
													<v-col cols="auto">
														<v-icon
																small
																@click="$_csvStpLyt_delete(item)">
															delete
														</v-icon>
													</v-col>
												</v-row>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-card>
							<v-card	class="customVCard"
									color="transparent"
									flat>
								<v-row class="pt-3">
									<v-col>
										<v-row dense justify="center">
											<v-col cols="auto">
												<v-btn	class="customVBtn"
														@click="stepNumber_--">
													Back
												</v-btn>
											</v-col>
											<v-col cols="auto">
												<v-btn	class="customVBtn"
														@click="$_csvStpLyt_submit()">
													Submit
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-card>
							<v-dialog v-model="showDialogEdit_" max-width="500px">
								<v-card>
									<v-card-title>
										<span class="headline">Edit</span>
									</v-card-title>
									<v-card-text>
										<template v-for="(contentVals, contentKey) in contents">
											<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
												<v-row :key="contentKey" dense>
													<v-col>
														<!-- integer -->
														<template v-if="contentVals.dataType.integer">
															<validation-provider
																	:name="contentKey"
																	:rules="contentVals.isNullable ? 'numeric' : 'required|numeric'"
																	v-slot="{ errors }">
																<v-text-field
																		v-model="editItem_[contentKey]"
																		:label="contentVals.headerText"
																		:error-messages="errors" />
															</validation-provider>	
														</template>
														<!-- string -->
														<template v-if="contentVals.dataType.string">
															<validation-provider
																	:name="contentKey"
																	:rules="contentVals.isNullable ? '' : 'required'"
																	v-slot="{ errors }">
																<v-text-field
																		v-model="editItem_[contentKey]"
																		:label="contentVals.headerText"
																		:error-messages="errors" />
															</validation-provider>	
														</template>
														<!-- date -->
														<template v-if="contentVals.dataType.date">
															<validation-provider
																	:name="contentKey"
																	:rules="contentVals.isNullable ? '' : 'required'"
																	v-slot="{ errors }">
																<v-text-field
																		v-model="editItem_[contentKey]"
																		:label="contentVals.headerText"
																		:error-messages="errors" />
															</validation-provider>	
														</template>
														<!-- time -->
														<template v-if="contentVals.dataType.time">
															<validation-provider
																	:name="contentKey"
																	:rules="contentVals.isNullable ? '' : 'required'"
																	v-slot="{ errors }">
																<v-text-field
																		v-model="editItem_[contentKey]"
																		:label="contentVals.headerText"
																		:error-messages="errors" />
															</validation-provider>	
														</template>
														<!-- date time -->
														<template v-if="contentVals.dataType.dateTime">
															<validation-provider
																	:name="contentKey"
																	:rules="contentVals.isNullable ? '' : 'required'"
																	v-slot="{ errors }">
																<v-text-field
																		v-model="editItem_[contentKey]"
																		:label="contentVals.headerText"
																		:error-messages="errors" />
															</validation-provider>	
														</template>
														<!-- boolean -->
														<template v-if="contentVals.dataType.boolean">
															<validation-provider
																	:name="contentKey"
																	:rules="contentVals.isNullable ? 'min-value:0|max-value:1' : 'required|min-value:0|max-value:1'"
																	v-slot="{ errors }">
																<v-text-field
																		v-model="editItem_[contentKey]"
																		:label="contentVals.headerText"
																		:error-messages="errors" />
															</validation-provider>	
														</template>
														<!-- json -->
														<template v-if="contentVals.dataType.json">
															<validation-provider
																	:name="contentKey"
																	:rules="contentVals.isNullable ? '' : 'required'"
																	mode="lazy"
																	v-slot="{ errors }">
																<v-text-field
																		v-model="editItem_[contentKey]"
																		:label="contentVals.headerText"
																		:error-messages="errors" />
															</validation-provider>	
														</template>
													</v-col>
												</v-row>
											</template>
										</template>
									</v-card-text>
									<v-card-actions>
										<v-row dense justify="center">
											<v-col cols="auto">
												<v-btn	class="customVBtn"
														@click="$_csvStpLyt_save()">
													Save
												</v-btn>
											</v-col>
											<v-col cols="auto">
												<v-btn	class="customVBtn"
														@click="showDialogEdit_ = !showDialogEdit_">
													Cancel
												</v-btn>
											</v-col>
										</v-row>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</v-stepper-content>
					</v-stepper-items>
					<!-- finished -->
					<v-stepper-items class="stepperItem_">
						<v-stepper-content class="stepperContent_" :step="3">
							<v-card class="customVCard">
								<v-card-title>Finished</v-card-title>
								<v-card-text>
									<v-row>
										<v-col>
											<span v-text="$_csvStpLyt_langFinishedText" />
										</v-col>
									</v-row>
									<v-row class="pt-4" no-gutters>
										<v-col>
											<v-alert text color="info">
												<v-row align="center">
													<v-col>
														Successfully submitted! (ID : <span v-text="submittedId_" />)
													</v-col>
													<v-col cols="auto">
														<clipboard-button :text="submittedId_" />
													</v-col>
												</v-row>
											</v-alert>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
							<v-card	class="customVCard"
									color="transparent"
									flat>
								<v-row class="pt-3" dense justify="center">
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												@click="openLink($_csvStpLyt_linkOkButton)">
											OK
										</v-btn>
									</v-col>
								</v-row>
							</v-card>
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'csvStepperLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				// stepper
				stepNumber_: 1,
				// form
				form_: {},
				// upload
				tabNumber_: 0,
				csvFileLocal_: null,
				showDialogUpload_: false,
				errorMessageUpload_: null,
				// edit csv data
				showDialogEdit_: false,
				editItem_: {},
				editKey_: 0,
				// submit
				submittedId_: null,
				errorMessageSubmit_: null
			}
		},
		computed: {
			// current user
			$_csvStpLyt_currentUser() {
				const self_ = this;
				return self_.getCurrentUser();
			},
			// state
			$_csvStpLyt_stateComponentIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getComponentState('isInitialized');
				return initialized_[self_.componentName_];
			},
			$_csvStpLyt_statePageName() {
				const self_ = this;
				return self_.getPageState('name')
			},
			$_csvStpLyt_statePageType() {
				const self_ = this;
				return self_.getPageState('type')
			},
			// link
			$_csvStpLyt_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.inits, 'okButton')
			},
			// lang
			$_csvStpLyt_langFinishedText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishedText')
				return self_.getLangsVal(lang_)
			},
			// style
			$_csvStpLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_csvStpLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_csvStpLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			}
		},
		created() {
			const self_ = this;
			
			self_.$_csvStpLyt_setInputState()
		},
		methods: {
			$_csvStpLyt_setInputState() {
				const self_ = this;

				self_.setInputState('pageName', self_.$_csvStpLyt_statePageName)
				self_.setInputState('pageType', self_.$_csvStpLyt_statePageType)

				let header_ = []
				// csv
				Object.keys(self_.contents).forEach(key => {
					header_.push({
						text: self_.contents[key].headerText,
						value: key
					})
				})

				let data_ = self_.getInputState('data')
				data_.header = header_
				data_.rows = []

				self_.setInputState('data', data_)
			},
			$_csvStpLyt_clear() {
				const self_ = this;
				const refs_ = self_.$refs;
				refs_.observer.reset()
				self_.form_ = {}
			},
			$_csvStpLyt_add(andContinue) {
				const self_ = this;

				let item_ = {}
				Object.keys(self_.contents).forEach(key => {
					if(self_.isEmpty(self_.form_[key])) { item_[key] = null }
					else {
						// integer
						if(self_.contents[key].dataType.integer) {
							item_[key] = Number(self_.form_[key])
						}
						// the other types
						else{
							item_[key] = self_.form_[key]
						}
					}
				})

				let data_ = self_.getInputState('data')
				data_.rows.push(item_)
				self_.setInputState('data', data_)

				if(!andContinue) {
					self_.$_csvStpLyt_clear()
					self_.stepNumber_++;
				}
			},
			$_csvStpLyt_uploadByFile() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.readFile(self_.csvFileLocal_)
				}).then(result => {
					const file_ = result;
					const header_ = self_.getCsvHeader(file_)
					const rows_ = self_.getCsvRows(file_)

					// check header
					if(!self_.checkCsvFormat(header_)) {
						self_.errorMessageUpload_ = 'Wrong file format'
					} else {
						const data_ = self_.getInputState('data')
						// make csv item
						rows_.forEach(row => {
							if(row.length == header_.length) {
								let item_ = {}
								Object.keys(self_.contents).forEach(key => {
									if(self_.isEmpty(row[0])) { item_[key] = null }
									else {
										// integer
										if(self_.contents[key].dataType.integer) {
											item_[key] = Number(row[0])
										}
										// json
										if(self_.contents[key].dataType.json) {
											item_[key] = JSON.parse(row[0])
										}
										// the other types
										else{
											item_[key] = row[0]
										}
									}
									row.shift()
								})

								const data_ = self_.getInputState('data')
								data_.rows.push(item_)
								self_.setInputState('data', data_)
							}
						})
						// close dialog and next
						self_.showDialogUpload_ = false;
						self_.stepNumber_++;
					}
				})
			},
			$_csvStpLyt_getDataTableHeaders() {
				const self_ = this;

				const data_ = self_.getInputState('data')

				let result_ = []
				// row number
				result_.push({ text: 'Row', value: 'row' })
				// data
				data_.header.forEach(item => {
					result_.push(item)
				})
				// action
				result_.push({ text: 'Action', value: 'action' })

				return result_
			},
			$_csvStpLyt_getDataTableItems() {
				const self_ = this;

				const data_ = self_.getInputState('data')

				let result_ = []
				let count_ = 1;

				data_.rows.forEach(item => {
					item.row = count_;
					result_.push(item)

					count_++;
				})

				return result_
			},
			$_csvStpLyt_downloadCsvFormat() {
				const self_ = this;

				const data_ = self_.getInputState('data')

				let header_ = '';
				header_ += '\ufeff';

				let first_ = true;
				data_.header.forEach(item => {
					if(first_) { first_ = false; }
					else {
						header_ += ','
					}
					header_ += item.text;
				})
				header_ += '\n';

				const blob_ = new Blob([header_], { type: 'text/csv' })
				let link_ = document.createElement('a')
				link_.href = window.URL.createObjectURL(blob_)
				link_.download = 'header.csv';
				link_.click()
			},
			$_csvStpLyt_edit(item) {
				const self_ = this;
				Object.keys(item).forEach(key => {
					if(key == 'row') {
						self_.editKey_ = item[key] - 1;
					} else {
						self_.editItem_[key] = item[key]
					}
				})
				self_.showDialogEdit_ = true;
			},
			$_csvStpLyt_delete(item) {
				console.log(item)
			},
			$_csvStpLyt_save() {
				const self_ = this;

				let data_ = self_.getInputState('data')
				Object.keys(self_.editItem_).forEach(key => {
					data_.rows[self_.editKey_][key] = self_.editItem_[key]	
				})
				self_.setInputState('data', data_)

				self_.editItem_ = {}
				self_.showDialogEdit_ = false;
			},
			$_csvStpLyt_cancel() {
				const self_ = this;
				self_.editItem_ = {}
				self_.showDialogEdit_ = false;
			},
			$_csvStpLyt_submit() {
				const self_ = this;

				let data_ = self_.getInputState('data')
				data_.headers

				Promise.resolve().then(() => {
					return self_.storeInput()
				}).then(result => {
					self_.submittedId_ = result.id;
					self_.stepNumber_++;
				}).catch(error => {
					self_.errorMessageSubmit_ = error;
				})
			}
		}
	};
</script>

<style scoped>
	.error_ {
		color: #ff5252;
	}
	.pretty_ {
		border: none;
	}
	.stepper_ {
		box-shadow: none;
		background-color: transparent;
	}
	.stepperHeader_ {
		background-color: transparent;
		box-shadow: none;
		height: 80px;
	}
	.stepperItem_ {
		background-color: transparent;
		box-shadow: none;
	}
	.stepperStep_ {
		padding: 16px !important;
	}
	.stepperContent_ {
		margin: 0 !important; 
		padding: 0 !important;
	}
</style>